"use strict";
function splitTextToCharacters(text) {
  return Array.from ? Array.from(text) : text.split("");
}
exports.splitTextToCharacters = splitTextToCharacters;
//# sourceMappingURL=splitTextToCharacters.js.map
